export default __webpack_public_path__ + "static/media/seats_grey.5e74ebe0.svg";